import styles from './region.module.scss'
import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { compare } from 'utils'

//antd
import { Input, Row, Col, Table, Button, notification, Popconfirm } from 'antd'

//icons
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'

//components
import RegionForm from './region-form'

//apis
import { getRegions, deleteRegion } from 'apis/region'
import { getCountries } from 'apis/country'

export default function Region() {
  const typingTimeoutRef = useRef(null)

  const [loading, setLoading] = useState(false)
  const [regions, setRegions] = useState([])
  const [countRegion, setCountRegion] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [allCountry, setAllCountry] = useState([])

  const [valueSearch, setValueSearch] = useState('')
  const onSearch = (e) => {
    setValueSearch(e.target.value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.name = value
      else delete paramsFilter.name

      paramsFilter.page = 1
      setParamsFilter({ ...paramsFilter })
    }, 650)
  }

  const _deleteRegion = async (id) => {
    try {
      setLoading(true)
      const res = await deleteRegion([id])
      if (res.status === 200) {
        if (res.data.success) {
          _getRegions()
          notification.success({ message: 'Xóa khu vực thành công' })
        } else
          notification.error({
            message: res.data.message || 'Xóa khu vực thất bại, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Xóa khu vực thất bại, vui lòng thử lại',
        })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const _getRegions = async () => {
    try {
      setLoading(true)
      const res = await getRegions({ ...paramsFilter })
      if (res.status === 200) {
        setRegions(res.data.data)
        setCountRegion(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const columns = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
    },
    {
      title: 'Mã khu vực',
      render: (text, record) => (
        <RegionForm countries={allCountry} infoRegion={record} reloadData={_getRegions}>
          <a>{record.code}</a>
        </RegionForm>
      ),
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: 'Tên khu vực',
      dataIndex: 'name',
      render: (text, record) => <div>{text}</div>,
      sorter: (a, b) => compare(a, b, 'name'),
    },
    {
      title: 'Tên quốc gia',
      render: (text, record) => record.country_info && record.country_info.name,
    },
    {
      title: 'Danh sách chi nhánh',
      render: (text, record) =>
        record.branch_infos && record.branch_infos.map((e) => e.name).join(', '),
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'create_date',
      render: (text, record) => (text ? moment(text).format('DD-MM-YYYY HH:mm') : ''),
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
    },
    {
      title: 'Độ ưu tiên',
      dataIndex: 'priority',
    },
    {
      title: 'Hành động',
      render: (text, record) => (
        <Popconfirm
          onConfirm={() => _deleteRegion(record.region_id)}
          title="Bạn có muốn xóa khu vực này không?"
        >
          <Button icon={<DeleteOutlined />} type="primary" danger />
        </Popconfirm>
      ),
    },
  ]

  const _getAllCountry = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setAllCountry(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    _getAllCountry()
  }, [])

  useEffect(() => _getRegions(), [paramsFilter])

  return (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid rgb(236, 226, 226)', paddingBottom: '0.75rem' }}
      >
        <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>Quản lý khu vực</div>
        <RegionForm countries={allCountry} reloadData={_getRegions}>
          <Button size="large" icon={<PlusCircleOutlined />} type="primary">
            Thêm khu vực
          </Button>
        </RegionForm>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={11} lg={11} xl={7}>
          <Input
            size="large"
            style={{ width: '100%' }}
            name="name"
            value={valueSearch}
            enterButton
            onChange={onSearch}
            placeholder="Tìm kiếm theo tên khu vực"
            allowClear
          />
        </Col>
      </Row>

      <Table
        size="small"
        rowKey="_id"
        loading={loading}
        columns={columns}
        dataSource={regions}
        style={{ width: '100%', marginTop: 20 }}
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: [20, 30, 40, 50, 70, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countRegion,
        }}
      />
    </div>
  )
}
